import React, { useEffect } from 'react';

import { useAtom } from 'jotai';
import { Outlet, useLocation } from 'react-router-dom';

import {
  BlocNav,
  CnuFooter,
  CnuHeader,
  CnuModal,
  CnuNav,
  isBlocCustomerAtom,
} from '@consumer-frontend/components';
import { Container } from '@consumer-frontend/shared-ui';

import { AccountHomeGondola } from './AccountHomeGondola/AccountHomeGondola';
import { analytics } from '../utils/adobe-analytics';

import '@consumer-bootstrap/index.scss';

export const RootPage: React.FC = () => {
  const location = useLocation();
  const [isBlocCustomer] = useAtom(isBlocCustomerAtom);

  useEffect(() => {
    analytics.track('routingChange', {
      to_path: location.pathname,
    });
  }, [location.pathname]);

  return (
    <>
      <CnuHeader isBlocCustomer={isBlocCustomer} />
      <Container className="root-container d-flex">
        {isBlocCustomer
          ? (
            <BlocNav
              displayNone
              responsiveFlexClass="d-md-flex"
              hasBoxShadow
            />
          )
          : (
            <CnuNav
              displayNone
              responsiveFlexClass="d-md-flex"
              hasBoxShadow
            />
          )}
        <Outlet />
      </Container>
      <CnuFooter />
      <CnuModal />
      <AccountHomeGondola />
    </>
  );
};
